// import CourseMethods from './CourseMethods'

// export default { CourseMethods }

module.exports = {
  Course: require('./CourseMethods')
}



// WEBPACK FOOTER //
// ./src/methods/index.js